import React from "react";
import styles from "./mobile-price-layout.module.scss";
import { formatCurrency } from "../../../../utils/utils";
import PriceDropTag from "../../pricedrop-tag";

const MobilePriceLayout = ({
  amount,
  Status,
  currencyCode,
  locale,
  bed,
  bath,
  car,
  sqft,
  house,
  sqftText,
  address,
  lotSizeSqFt,
  lotSizeSqFtText,
  objStatus,
  priceDrop,
  priceDropDate,
  type
}: any) => {
  return (
    <div className={styles.priceBox} tabIndex={4}>
      <PriceDropTag
        type={type}
        priceDrop={priceDrop}
        priceDropDate={priceDropDate}
      />
      <div className={styles.priceWrap}>
        <span className={styles.amount}>
          {formatCurrency(amount, currencyCode, locale, 0, 0)}
        </span>
        {objStatus && (
          <span
            className={styles.status}
            style={{
              backgroundColor: Status?.bgColor,
              color: Status?.txtColor
            }}
          >
            {objStatus}
          </span>
        )}
      </div>
      <div className={styles.address} tabIndex={6}>
        {address}
      </div>

      <ul className={styles.list} tabIndex={7}>
        {bed && (
          <li tabIndex={8}>
            <img src="/images/bed.svg" className={styles.img} alt="" />
            {bed}
          </li>
        )}
        {bath && (
          <li tabIndex={9}>
            <img src="/images/bath.svg" className={styles.img} alt="" />
            {bath}
          </li>
        )}
        {car && (
          <li tabIndex={10}>
            <img src="/images/car.svg" className={styles.img} alt="" />
            {car}
          </li>
        )}
        {sqft.length > 0 && (
          <li tabIndex={11}>
            <img src="/images/sqft.svg" className={styles.img} alt="" />
            {`${sqft} ${sqftText}`}
          </li>
        )}
        {lotSizeSqFt && (
          <li className={styles.accessory}>
            <img src="/images/sqft.svg" alt="" className={styles.img} />
            {`${lotSizeSqFt} ${lotSizeSqFtText}`}
          </li>
        )}
        {house && <li tabIndex={12}>{house}</li>}
      </ul>
    </div>
  );
};

export default React.memo(MobilePriceLayout);
